import { combineReducers } from "@reduxjs/toolkit";
import partnersReducer from "Dashboard/scenes/Partners/reducers";
import stockReducer from "Dashboard/scenes/Stock/reducers";
import cbReducer from "Dashboard/scenes/ConcreteBase/reducers";
import hrReducer from "Dashboard/scenes/HumanResources/reducers";
import hrsReducer from "Dashboard/scenes/HighRiseSales/reducers";
import consumablesReducer from "Dashboard/scenes/Consumables/reducers";
import resourcesReducer from "Dashboard/scenes/Resources/reducers";
import projectsReducer from "Dashboard/scenes/Projects/reducers";
import carnetsReducer from "Dashboard/scenes/Carnets/reducers";
import incidentsReducer from "Dashboard/scenes/Incidents/incident.slice";
import dtReducer from "Dashboard/scenes/DailyTable/reducers";
import statisticsReducer from "Dashboard/scenes/Statistics/reducers";
import chatReducer from "Dashboard/scenes/Chat/chat.slice";
import requisitionReducer from "Dashboard/scenes/Requisitions/requisition.slice";
import reportsReducer from "Dashboard/scenes/Reports/reports.slice";
import expensesReducer from "Dashboard/scenes/Expenses/reducers";
import loginReducer from "Dashboard/login.slice";
import dashboardReducer from "Dashboard/dashboard.slice";
import authReducer from "authentication/main.slice";

const rootReducer = combineReducers({
  auth: authReducer,
  dashboard: dashboardReducer,
  login: loginReducer,
  chat: chatReducer,
  requisition: requisitionReducer,
  reports: reportsReducer,
  stock: stockReducer,
  cb: cbReducer,
  partners: partnersReducer,
  hr: hrReducer,
  hrs: hrsReducer,
  consumables: consumablesReducer,
  resources: resourcesReducer,
  projects: projectsReducer,
  carnets: carnetsReducer,
  incidents: incidentsReducer,
  dailytable: dtReducer,
  statistics: statisticsReducer,
  expenses: expensesReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
